<div *ngIf="chartData">
<canvas #myCanvas class="canvastime" width="477" height="320" baseChart [chartType]="chartType" [datasets]="chartData" [labels]="chartLabels" [colors]="chartColors" [options]="chartOptions"></canvas>
</div>